import { ListItemIcon } from "@mui/material";
import CustomMenuItem from "../../Menu/CustomMenuItem";
import { isAdmin } from "../../../utils/constants";
import React from "react";

export const ProfileMenuItem = React.memo(({menuItem, handleMenuClick}) => {
    // Check permission
    if (menuItem.permission === 'admin' && !isAdmin()) {
        return null;
    }

    return (
        <CustomMenuItem
            key={menuItem.id}
            onClick={() => handleMenuClick(menuItem)}
            className={menuItem.className}
        >
            <ListItemIcon sx={{ minWidth: "26px !important" }}>
                <img src={menuItem.icon} alt={menuItem.alt} />
            </ListItemIcon>
            {menuItem.label}
        </CustomMenuItem>
    );
});
